<template>
  <section></section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'
import globals from '@/plugins/globals'
const signalrUrl = window.config ? window.config.signalrUrl : ''
export default {
  name: 'service-hub',
  data() {
    return {
      connection: null,
      signalRstatus: '',
      signalRerror: '',
      connectedInterval: 0
    }
  },
  mounted() {
    this.$eventBus.$on('push-message', this.pushMessage)
    this.initSignalR()
  },
  computed: {
    ...mapGetters('auth', ['token', 'profile']),
    isShop() {
      let _is = false
      if (this.profile.roles[0] === 4 || this.profile.roles[0] === 5) {
        _is = true
      }
      return _is
    },
    isCenter() {
      let _is = false
      if (this.profile.roles[0] === 8 || this.profile.roles[0] === 9) {
        _is = true
      }
      return _is
    }
  },
  methods: {
    ...mapActions('calibrates', ['setCalibrateCounts']),
    initSignalR() {
      try {
        // Initialize SignalR
        if (this.connection === null) {
          this.connection = new HubConnectionBuilder()
            .withUrl(signalrUrl)
            .withAutomaticReconnect([0, 3000, 5000, 10000, 15000, 30000, 60000])
            .configureLogging(LogLevel.Information)
            .build()
          // Listen to "sendMessage"
          this.connection.on('sendMessage', (data) => {
            if (data !== undefined && data !== null) {
              if (globals.isJson(data)) {
                let msg = JSON.parse(data)
                if (msg.message !== null) {
                  if (globals.isJson(msg.message)) {
                    msg.message = JSON.parse(msg.message)
                    // console.log('Service Hub: Incoming Message', {msg: msg, isCenter: this.isCenter})
                    if (msg.type === 'Counts') {
                      if (this.isCenter && msg.target === 'Center') {
                        this.setCalibrateCounts(msg)
                      } else if (this.isShop && msg.target === 'Shop') {
                        if (parseInt(msg.id) === parseInt(this.profile.firm)) {
                          this.setCalibrateCounts(msg)
                        }
                      }
                    } else if (msg.type === 'Chat') {
                      if (msg.event === 'Incoming') {
                        console.log('Incoming Chat', msg)
                      }
                    } else if (msg.type === 'Status') {
                      if (parseInt(msg.id) === parseInt(this.profile.firm)) {
                        console.log('Status Change', msg)
                        if (this.isShop && msg.target === 'Shop') {
                        } else if (this.isCenter && msg.target === 'Center') {
                        }
                      }
                    }
                  }
                }
                // console.log('Received Message', msg)
              }
            }
          })
          // Start SignalR connection
          this.connection
            .start()
            .then(() => {
              console.log('Service Hub Started')
            })
            .catch((err) => {
              console.error(err.toString())
            })
        }
      } catch (e) {
        console.error('Error: serviceHub > initSignalR', e)
      }
    },
    pushMessage(message) {
      this.connection
        .invoke('sendChatPush', JSON.stringify(message))
        .then((result) => {
          console.log('serviceHub: Pushed a Message', result)
        })
        .catch((err) => {
          console.error(err.toString())
        })
    }
  },
  beforeDestroy() {
    this.$eventBus.$off('push-message')
    this.connection.stop().then(() => {
      this.connection = null
      console.log('Service Hub Stopped')
    })
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/service-hub.vue